import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { aboutImage, aboutImageSmall } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function AboutSection() {
  const { t } = useLang();
  const bullets = [
    t('about.b.cra'),
    t('about.b.pricing'),
    t('about.b.year'),
    t('about.b.cross'),
    t('about.b.audit'),
    t('about.b.secure'),
  ];
  return (
    <section className="py-24 md:py-28 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-32 h-32 dotted-pattern opacity-70 hidden md:block" />
          <div className="relative rounded-xl overflow-hidden border-[8px] border-white shadow-[0_25px_60px_-25px_rgba(20,17,15,0.35)]">
            <img src={aboutImage} alt="WYSE Tribe team" className="w-full h-[500px] object-cover" />
          </div>
          <div className="absolute bottom-8 -right-4 md:-right-12 w-64 rounded-xl overflow-hidden border-[6px] border-white shadow-[0_18px_40px_-18px_rgba(20,17,15,0.45)]">
            <img src={aboutImageSmall} alt="Business professionals in consultation" className="w-full h-44 object-cover" />
          </div>
        </div>

        <div>
          <p className="section-eyebrow mb-4">{t('about.eyebrow')}</p>
          <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
            {t('about.titlePre')} <span className="text-[#f5b300]">{t('about.titleAccent')}</span>
          </h2>
          <p className="mt-5 text-[15.5px] text-neutral-600 leading-relaxed">{t('about.desc')}</p>

          <div className="mt-7 grid grid-cols-2 gap-x-6 gap-y-3">
            {bullets.map((b) => (
              <div key={b} className="flex items-center gap-2.5">
                <span className="w-6 h-6 rounded-full bg-[#f5b300]/15 flex items-center justify-center shrink-0">
                  <CheckCircle2 className="w-4 h-4 text-[#f5b300]" />
                </span>
                <span className="text-[14.5px] font-medium text-[#14110f]">{b}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center gap-6">
            <div className="flex -space-x-3">
              {[
                'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80&auto=format&fit=crop',
                'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&q=80&auto=format&fit=crop',
                'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80&auto=format&fit=crop',
                'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=120&q=80&auto=format&fit=crop',
              ].map((src, i) => (
                <img key={i} src={src} alt="" className="w-11 h-11 rounded-full border-[3px] border-white object-cover" />
              ))}
            </div>
            <div>
              <p className="text-[15px] font-bold text-[#14110f]">{t('about.advisors')}</p>
              <p className="text-[12.5px] text-neutral-500">{t('about.cpaLine')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
